import classNames from "classnames";
import { Form } from "formik";
import { PropsWithChildren } from "react";
import { useTestAttributes } from "../testAttributes";

export interface Props extends PropsWithChildren<Record<string, any>> {
    as?: React.ElementType;
    className?: string;
    defaultStyle: string;
}

/*
 * Abstract container implementation.
 * For examples of extension, see PageContainer, CardsContainer
 * Intended for applying container styling - not to be confused with a data container
 * Use `as` prop to render alternate element or Custom component
 */

export const Container = ({ as: Component = "div", children, className, defaultStyle, ...rest }: Props) => {
    const { getTestId } = useTestAttributes();

    const testAttributes = {};

    if (Component === Form || Component === "form") {
        testAttributes["data-testid"] = getTestId({ element: "form" });
    }

    return (
        <Component className={classNames(defaultStyle, className)} {...testAttributes} {...rest}>
            {children}
        </Component>
    );
};
